import { render, staticRenderFns } from "./WaiterJudgeTemplateSelectItem.vue?vue&type=template&id=f015d598&scoped=true&lang=pug"
import script from "./WaiterJudgeTemplateSelectItem.vue?vue&type=script&lang=ts"
export * from "./WaiterJudgeTemplateSelectItem.vue?vue&type=script&lang=ts"
import style0 from "./WaiterJudgeTemplateSelectItem.vue?vue&type=style&index=0&id=f015d598&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f015d598",
  null
  
)

export default component.exports